import { IconPropsType } from '..';

export const WhatsAppIcon = ({ ...props }: IconPropsType) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_11058_132377)">
      <circle
        cx="12"
        cy="12"
        r="12"
        fill="#263424"
      />
      <path
        d="M4.80005 19.1998L5.83275 15.3481C5.248 14.2935 4.94077 13.1115 4.94077 11.9122C4.93998 7.99016 8.13112 4.7998 12.0524 4.7998C15.9737 4.7998 19.1649 7.99016 19.1649 11.9122C19.1649 15.8343 15.9745 19.0247 12.0524 19.0247C10.8751 19.0247 9.71262 18.7276 8.6721 18.1632L4.80005 19.1998ZM8.86441 16.7193L9.10832 16.8647C10.0034 17.3979 11.0221 17.6801 12.0524 17.6801C15.2326 17.6801 17.8202 15.0924 17.8202 11.9122C17.8202 8.73205 15.2326 6.14443 12.0524 6.14443C8.87223 6.14443 6.28461 8.73127 6.28461 11.9122C6.28461 12.9622 6.57621 13.9964 7.12813 14.9025L7.27744 15.1479L6.70129 17.2986L8.86441 16.7193Z"
        fill="#2AB318"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.6979 12.9012C14.4047 12.7261 14.024 12.5306 13.6793 12.6713C13.415 12.7792 13.2454 13.1936 13.0742 13.4054C12.9866 13.5141 12.8811 13.5313 12.7458 13.4765C11.753 13.081 10.9916 12.418 10.4436 11.5042C10.3505 11.3619 10.3669 11.2501 10.4795 11.1188C10.6452 10.9241 10.8532 10.7021 10.8978 10.4394C10.9423 10.1767 10.8196 9.86951 10.7109 9.63577C10.5718 9.33713 10.417 8.91029 10.1176 8.74143C9.84238 8.58586 9.47965 8.67264 9.23417 8.87277C8.81124 9.21753 8.60642 9.75772 8.61268 10.2924C8.61424 10.4441 8.633 10.5965 8.66896 10.7427C8.75417 11.0961 8.91756 11.4252 9.10127 11.7387C9.23965 11.9748 9.39053 12.2046 9.55235 12.4251C10.0839 13.1466 10.7445 13.7736 11.5099 14.2427C11.8922 14.4764 12.3041 14.682 12.7302 14.8227C13.2086 14.9807 13.6347 15.1448 14.1514 15.0471C14.6924 14.9447 15.2256 14.6101 15.4398 14.0887C15.5031 13.9347 15.5352 13.7627 15.4992 13.5993C15.4257 13.2623 14.9699 13.0622 14.6971 12.8988L14.6979 12.9012Z"
        fill="#2AB318"
      />
    </g>
    <defs>
      <clipPath id="clip0_11058_132377">
        <rect
          width="24"
          height="24"
          fill="white"
        />
      </clipPath>
    </defs>
  </svg>
);
